// Import cookie with interop handling for UMD modules
import cookieImport from 'Libs/cookie/cookie.js';

// Handle both ESM and CommonJS exports
const cookie = (typeof cookieImport === 'object' && cookieImport !== null && cookieImport.default) 
	? cookieImport.default 
	: cookieImport;

// Lazy initialize cookie values to ensure module is loaded
let cookieState = {
	acceptedCookiesFunctional: false,
	acceptedCookiesStatistics: false,
	consentExecuted: false
};

// Initialize on first access
function initializeCookieState() {
	try {
		if (cookie && typeof cookie.get === 'function') {
			cookieState = {
				acceptedCookiesFunctional: cookie.get('FMV_accepted_cookies_functional') === '1',
				acceptedCookiesStatistics: cookie.get('FMV_accepted_cookies_statistics') === '1',
				consentExecuted: cookie.get('FMV_consent_executed') === '1'
			};
		}
	} catch (e) {
		console.warn('Failed to initialize cookie state:', e);
	}
}

// Call initialization immediately
initializeCookieState();

export default {

	preset: window.FMV_PRESET || {},
	config: {
		size: {
			s: 640,
			m: 768,
			l: 1280,
			xl: 1440,
			nav: 'm'
		}
	},
	state: {
		isInIframe: top !== self,
		get acceptedCookiesFunctional() {
			return cookieState.acceptedCookiesFunctional;
		},
		set acceptedCookiesFunctional(value) {
			cookieState.acceptedCookiesFunctional = value;
		},
		get acceptedCookiesStatistics() {
			return cookieState.acceptedCookiesStatistics;
		},
		set acceptedCookiesStatistics(value) {
			cookieState.acceptedCookiesStatistics = value;
		},
		get consentExecuted() {
			return cookieState.consentExecuted;
		},
		set consentExecuted(value) {
			cookieState.consentExecuted = value;
		}
	}

};